import { isDraft } from '@/pages/home/utils';
import { LibraryItem } from '@d-id/types';
import styled from '@emotion/styled';
import { EditableTitle } from '../Title/EditableTitle';
import { VideoDate } from '../VideoDate';

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 12px;
`;

const VideoTitle = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
`;

const StyledEditableTitle = styled(EditableTitle)`
    font-weight: 400;
    overflow: visible;
    word-break: break-word;
    word-wrap: break-word;
    max-width: 100%;
`;

interface Props {
    item: LibraryItem;
    videoName: string;
    setVideoName: (value: string) => void;
    handleBlur: (value: string) => Promise<void>;
    formattedDate: string;
    isError: boolean;
    readOnly?: boolean;
}

export const VideoTileInfo = ({ item, videoName, setVideoName, handleBlur, formattedDate, isError, readOnly = false }: Props) => (
    <InfoContainer>
        {isError || readOnly ? (
            <VideoTitle>{item.name}</VideoTitle>
        ) : (
            <StyledEditableTitle
                testId={`video-tile-title-${videoName}`}
                fontSize={16}
                value={videoName}
                onChange={setVideoName}
                placeholder="Type your video title here"
                onBlur={handleBlur}
                fontWeight={700}
            />
        )}
        <VideoDate formattedDate={isDraft(item) ? `Edited ${formattedDate}` : `Created ${formattedDate}`} />
    </InfoContainer>
);
